// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UXgpJgRk8TsyFJ4v8Ald{min-height:20px;color:var(--yellow-90);align-items:center;gap:4px;display:flex}.HkaqodGpYMiIX2B8rJ2G{line-height:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warning": `UXgpJgRk8TsyFJ4v8Ald`,
	"text": `HkaqodGpYMiIX2B8rJ2G`
};
export default ___CSS_LOADER_EXPORT___;
